module.exports = __webpack_public_path__ + "img/badge_ollipay.f92d306a.jpg";